
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery('header.header-site').addClass('scrolled');
    } else {
        jQuery('header.header-site').removeClass('scrolled');
    }
});


jQuery(document).ready(function($) {
    $('.embed-bg iframe').each(function() {
      var src = $(this).attr('src');
      if (src && (src.includes('youtube.com') || src.includes('youtu.be'))) {
        if (src.includes('?')) {
          src += '&autoplay=1&mute=1';
        } else {
          src += '?autoplay=1&mute=1';
        }
        $(this).attr('src', src);
        $(this).attr('allow', 'accelerometer; autoplay; autostop; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        $(this).attr('allowfullscreen', 'true');
      }
    });

    const videos = document.querySelectorAll(".video-blog video");
    videos.forEach(video => {
        const videoContainer = video.closest(".video-blog");
        const playButton = videoContainer.querySelector(".play-button");
        playButton.addEventListener("click", function() {
            video.play();
            playButton.style.display = "none";
        });
        video.addEventListener("pause", function() {
            playButton.style.display = "block";
        });
        video.addEventListener("ended", function() {
            playButton.style.display = "block";
        });
    });

    const megaMenu = document.querySelector(".mega-menu-toggle");
    const header = document.querySelector("#wrapper-navbar");
    if (megaMenu && header) {
        const observer = new MutationObserver(() => {
            if (megaMenu.classList.contains("mega-menu-open")) {
                header.style.backgroundColor = "#0d0d0d";
            } else {
                header.style.backgroundColor = "";
            }
        });
        observer.observe(megaMenu, { attributes: true, attributeFilter: ["class"] });
    }

    let moreBtn = document.querySelector(".social-btn.more i");
    let extraBtns = document.querySelector(".extra-social-buttons");
    if (moreBtn && extraBtns) {
        moreBtn.parentElement.addEventListener("click", function (event) {
            event.preventDefault();
            if (extraBtns.classList.contains("show")) {
                extraBtns.style.height = extraBtns.scrollHeight + "px";
                setTimeout(() => {
                    extraBtns.style.height = "0";
                    extraBtns.classList.remove("show");
                    moreBtn.classList.replace("fa-minus", "fa-plus");
                }, 10);
            } else {
                extraBtns.classList.add("show");
                extraBtns.style.height = extraBtns.scrollHeight + "px";
                setTimeout(() => {
                    extraBtns.style.height = "auto";
                }, 100);
                moreBtn.classList.replace("fa-plus", "fa-minus");
            }
        });
    }
});

const elements = document.querySelectorAll('.cover-with-parallax-detail figure, .cover-with-parallax-detail h1, .cover-with-parallax-detail h2, .cover-with-parallax-detail h3, .cover-with-parallax-detail h4, .cover-with-parallax-detail h5, .cover-with-parallax-detail h6, .cover-with-parallax-detail p, .cover-with-parallax-detail ul');
if (elements.length > 0) {
    elements.forEach(element => {
        element.setAttribute('data-aos', 'fade-up');
        element.setAttribute('data-aos-duration', '1000');
    });
} 

jQuery(document).ready(function($) {
    $('[tabindex="0"]').keydown(function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        $(this).click();
      }
    });
  });


/*skip content*/
document.addEventListener('DOMContentLoaded', function() {
    const LinkGoSecondSection = document.getElementById('GoSecondSection');
    LinkGoSecondSection.addEventListener('click', function(event) {
        event.preventDefault();
        const secondSection = document.querySelector('.general-section:nth-of-type(2)');
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: 'smooth' });
        } else {
            console.error('the second section was not found.');
        }
    });
});



function autosize() {
    var el = this;
    setTimeout(function() {
        el.style.cssText = 'height:auto; padding:0';
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = 'height:' + (el.scrollHeight + 2) + 'px';
    }, 0);
}


function createPopup() {
    const popup = document.createElement('div');
    popup.id = 'demo-popup';

    const popupContent = document.createElement('div');
    popupContent.className = 'popup-content';

    const closeButton = document.createElement('span');
    closeButton.className = 'close-button';
    closeButton.innerHTML = '&times;';

    const titleDiv = document.createElement('div');
    titleDiv.className = 'title-popup';

    const title = document.createElement('h3');
    title.textContent = 'Request a Demo';
    const description = document.createElement('p');
    description.textContent = 'Fill out the form below to receive a demo';

    titleDiv.appendChild(title);
    titleDiv.appendChild(description);

    const iframe = document.createElement('iframe');
    iframe.src = 'https://app.smartsheet.com/b/form/b780c7314d424c7b86a3c3b987028fb0';
    iframe.width = '100%';
    iframe.height = '400px';

    popupContent.appendChild(closeButton);
    popupContent.appendChild(titleDiv);
    popupContent.appendChild(iframe);
    popup.appendChild(popupContent);
    document.body.appendChild(popup);

    closeButton.onclick = function() {
        popup.classList.remove('active');
        setTimeout(() => popup.style.display = 'none', 400);
    }

    popup.onclick = function(event) {
        if (event.target === popup) {
            popup.classList.remove('active');
            setTimeout(() => popup.style.display = 'none', 400);
        }
    }

    return popup;
}

const popup = createPopup();

document.querySelectorAll('a[href="#popup"]').forEach(link => {
    link.onclick = function(event) {
        event.preventDefault();
        popup.style.display = 'block';
        setTimeout(() => popup.classList.add('active'), 10);
    };
});
